import React from "react";

const DinersTransaction = () => (
  <svg
    width="25"
    height="20"
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_491_2882)">
      <path
        d="M14.6904 20C20.1202 20.0262 25.0761 15.542 25.0761 10.0869C25.0761 4.12143 20.1202 -0.00198341 14.6904 7.15737e-07H10.0175C4.52274 -0.00198341 0 4.12266 0 10.0869C0 15.5432 4.52274 20.0262 10.0175 20H14.6904Z"
        fill="#0079BE"
      />
      <path
        d="M10.04 0.826172C5.01906 0.827759 0.950401 4.92498 0.949219 9.98177C0.950401 15.0377 5.01902 19.1345 10.04 19.1361C15.0622 19.1345 19.1317 15.0377 19.1324 9.98177C19.1316 4.92498 15.0622 0.827759 10.04 0.826172ZM4.27762 9.98177C4.28235 7.51074 5.81529 5.40359 7.97693 4.56625V15.396C5.81529 14.5591 4.28231 12.4532 4.27762 9.98177ZM12.1023 15.3984V4.56589C14.2648 5.40121 15.8001 7.50954 15.804 9.98177C15.8001 12.4547 14.2648 14.5615 12.1023 15.3984Z"
        fill="white"
      />
      <path
        d="M14.6904 20C20.1202 20.0262 25.0761 15.542 25.0761 10.0869C25.0761 4.12143 20.1202 -0.00198341 14.6904 7.15737e-07H10.0175C4.52274 -0.00198341 0 4.12266 0 10.0869C0 15.5432 4.52274 20.0262 10.0175 20H14.6904Z"
        fill="#0079BE"
      />
      <path
        d="M10.04 0.826172C5.01906 0.827759 0.950401 4.92498 0.949219 9.98177C0.950401 15.0377 5.01902 19.1345 10.04 19.1361C15.0622 19.1345 19.1317 15.0377 19.1324 9.98177C19.1316 4.92498 15.0622 0.827759 10.04 0.826172ZM4.27762 9.98177C4.28235 7.51074 5.81529 5.40359 7.97693 4.56625V15.396C5.81529 14.5591 4.28231 12.4532 4.27762 9.98177ZM12.1023 15.3984V4.56589C14.2648 5.40121 15.8001 7.50954 15.804 9.98177C15.8001 12.4547 14.2648 14.5615 12.1023 15.3984Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_2882">
        <rect width="25" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DinersTransaction;
